import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import GradientButton from './GradientButton';

interface Props {
  onButtonClick: () => void;
}

const useStyles = makeStyles((theme) => ({
  banner: {
    backgroundImage: "url('/images/game-banner.png')",
    backgroundPosition: '50% 50%',
  },
}));

const Banner: React.FC<Props> = ({ onButtonClick }) => {
  const { banner } = useStyles();
  return (
    <Box
      className={banner}
      bgcolor="#7683F9"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height={300}
    >
      <Box height={150} />
      <img
        src="/images/game-play-button.png"
        style={{ cursor: 'pointer' }}
        onClick={onButtonClick}
      />
    </Box>
  );
};

export default Banner;
